import clsx from 'clsx';

interface TabItem<T extends string> {
  id: T;
  label: string;
}

interface TabsProps<T extends string> {
  items: TabItem<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

export function Tabs<T extends string>({ items, value, onChange, className }: TabsProps<T>) {
  return (
    <div className={clsx('flex gap-6 border-b border-[var(--grid-line)] mb-6', className)}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onChange(item.id)}
          className={clsx(
            'pb-3 text-sm tracking-wide border-b-2 -mb-px transition-colors bg-transparent border-x-0 border-t-0 cursor-pointer',
            value === item.id
              ? 'text-daynote-text border-daynote-accent font-medium'
              : 'text-daynote-muted border-transparent hover:text-daynote-text',
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
